import { createUseStyles } from "react-jss";

export const AFAListStyle = createUseStyles({
	rowStyle: {
		"& div>table>tbody>tr>td": {
			padding: "8px 16px",
		},
	},
	headerContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "20px",
		padding: "16px 0",
	},
	searchContainer: {
		display: "flex",
		gap: "16px",
		alignItems: "center",
		marginBottom: "16px",
	},
	filterContainer: {
		display: "flex",
		gap: "16px",
		alignItems: "center",
		marginBottom: "16px",
	},
});